module.exports = __webpack_public_path__ + "img/user-guide-02-05-02.88fdc173.png";